module.exports = "https://static.im-cdn.com/mjc/storefront/Esteem/static/media/FooterTwitter.2d82f982.svg";